export default {
  dataCatalog: state => field => state[field]
};
